import { HasDependencies, hashString } from '../../api/types';
import { Domains } from '../../constants';
import { ApiMasterDataQueryFilterItem, Benchmark } from '../../types';
import { BaseAuthedTracker } from './baseTracker';

export interface ForecastType {
  type: string;
  label: string;
}

const SIDEBAR_OPENED_EVENT = '[Dashboard Sidebar] Opened';
const SIDEBAR_CLOSED_EVENT = '[Dashboard Sidebar] Closed';

const SIDEBAR_BENCHMARK_TOGGLE_EVENT = '[Dashboard Sidebar] Benchmark Toggled';

const SIDEBAR_SETTING_TOGGLE_LABEL_EVENT =
  '[Dashboard Sidebar] Setting: Label Toggled';
const SIDEBAR_SETTING_TOGGLE_PERCENTAGE_EVENT =
  '[Dashboard Sidebar] Setting: Percentage Toggled';

const SIDEBAR_SEGMENT_TOGGLE_EVENT = '[Dashboard Sidebar] Segment Toggled';

const SIDEBAR_FORECAST_TOGGLE_EVENT = '[Dashboard Sidebar] Forecast Toggled';

export class SidebarTracker implements HasDependencies {
  constructor(
    readonly tracker: BaseAuthedTracker,
    readonly domain: Domains
  ) {}

  public getDeps = () => [hashString([...this.tracker.getDeps(), this.domain])];

  public trackBenchmark = (benchmark: Benchmark) => {
    this.tracker.track(SIDEBAR_BENCHMARK_TOGGLE_EVENT, this.domain, {
      benchmarkType: benchmark.type,
      benchmarkValue: benchmark.value,
    });
  };

  public trackSettingLabelToggle = () => {
    this.tracker.track(SIDEBAR_SETTING_TOGGLE_LABEL_EVENT, this.domain);
  };

  public trackSettingPercentageToggle = () => {
    this.tracker.track(SIDEBAR_SETTING_TOGGLE_PERCENTAGE_EVENT, this.domain);
  };

  public trackSegment = (segment: ApiMasterDataQueryFilterItem) => {
    this.tracker.track(SIDEBAR_SEGMENT_TOGGLE_EVENT, this.domain, {
      segmentProperty: segment?.property,
      segmentOperation: segment?.operation,
      segmentValuesCount: Array.isArray(segment?.values)
        ? segment.values.length
        : undefined,
      segmentDataType: segment?.dataType,
    });
  };

  public trackForecast = (forecast: ForecastType) => {
    this.tracker.track(SIDEBAR_FORECAST_TOGGLE_EVENT, this.domain, {
      forecastType: forecast.type,
      forecastLabel: forecast.label,
    });
  };

  public trackOpenSidebar = () => {
    this.tracker.track(SIDEBAR_OPENED_EVENT, this.domain);
  };

  public trackHideSidebar = () => {
    this.tracker.track(SIDEBAR_CLOSED_EVENT, this.domain);
  };
}
